import publicClient from '@/api/publicClient'

/**
 * Fetch public calendar bootstrap data for a partner short id.
 *
 * @param {String} shortId
 * @return {Promise<Object>}
 */
export function fetchBootstrap(shortId) {
	return publicClient
		.get(`v1/partners/${shortId}/public-calendar/bootstrap`)
		.then(response => response.data)
}
